/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { getTeamUrl } from '../utils/routes';

export default function HeaderTeamLogo({ teams }) {
  return (
    <div className="team-bar">
      <div className="site-container team-bar__container">
        {Object.keys(teams).map((key) => {
          return (
            <a className="team-bar__item" href={getTeamUrl(key)}>
              <img
                key={key}
                src={teams[key].logoImageUrl}
                alt={teams[key].name}
              />
            </a>
          );
        })}
      </div>
    </div>
  );
}
